import {
  put, takeLatest, all, takeEvery,
} from 'redux-saga/effects';
import { notification } from 'antd';
import TrackerActions from '@Actions/trackerActions';
import reportV2Services from '../../services/ReportsV2/reportV2Services';
import ReportV2Actions, { reportV2ActionTypes } from '../../actions/Reports/reportV2Actions';

// get reports v2 List

function* _getReportsV2List(action) {
  const {
    params, callback,
  } = action;
  try {
    yield put(ReportV2Actions.getReportsV2ListLoading(true));
    const reportsV2List = yield reportV2Services.getReportsV2List(params);
    yield put(ReportV2Actions.getReportsV2ListSuccess(reportsV2List));
    yield put(ReportV2Actions.getReportsV2ListLoading(false));
    if (callback) {
      callback();
    }
  } catch (error) {
    yield put(ReportV2Actions.getReportsV2ListLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reportV2ActionTypes.GET_REPORTS_LIST_V2.ERROR, error));
  }
}

function* getReportsV2List() {
  yield takeEvery(reportV2ActionTypes.GET_REPORTS_LIST_V2.REQUEST, _getReportsV2List);
}

// filter reports v2 List

function* _filterReportsV2List(action) {
  const {
    params, callback,
  } = action;
  try {
    yield put(ReportV2Actions.filterReportsV2ListLoading(true));
    const reportsV2List = yield reportV2Services.filterReportsV2List(params);
    // yield put(ReportV2Actions.filterReportsV2ListSuccess(reportsV2List));
    if (!reportsV2List?.success) {
      notification.open({
        type: 'error',
        message: reportsV2List?.message,
        duration: 4,
        placement: 'top',
      });
      yield put(ReportV2Actions.filterReportsV2ListLoading(false));
    } else {
      yield put(ReportV2Actions.filterReportsV2ListLoading(false));
      if (callback) {
        callback();
      }
    }
  } catch (error) {
    yield put(ReportV2Actions.filterReportsV2ListLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reportV2ActionTypes.FILTER_REPORTS_LIST_V2.ERROR, error));
  }
}

function* filterReportsV2List() {
  yield takeEvery(reportV2ActionTypes.FILTER_REPORTS_LIST_V2.REQUEST, _filterReportsV2List);
}

// get reports v2 List Detail

function* _getReportsV2ListDetail(action) {
  const {
    params, callback,
  } = action;
  try {
    yield put(ReportV2Actions.getReportsV2ListDetailLoading(true));
    const reportsV2ListDetail = yield reportV2Services.getReportsV2ListDetail(params);
    yield put(ReportV2Actions.getReportsV2ListDetailSuccess(reportsV2ListDetail));
    yield put(ReportV2Actions.getReportsV2ListDetailLoading(false));
    if (callback) {
      callback();
    }
  } catch (error) {
    yield put(ReportV2Actions.getReportsV2ListDetailLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reportV2ActionTypes.GET_REPORTS_LIST_V2_DETAIL.ERROR, error));
  }
}

function* getReportsV2ListDetail() {
  yield takeEvery(reportV2ActionTypes.GET_REPORTS_LIST_V2_DETAIL.REQUEST, _getReportsV2ListDetail);
}

function* _deleteScheduledReport(action) {
  const {
    payload, callback,
  } = action;
  try {
    yield put(ReportV2Actions.deleteScheduledReportLoading(true));
    const reportsV2ListDetail = yield reportV2Services.deleteScheduledReport(payload);
    yield put(ReportV2Actions.deleteScheduledReportLoading(false));
    if (callback) {
      callback();
    }
  } catch (error) {
    yield put(ReportV2Actions.deleteScheduledReportLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reportV2ActionTypes.DELETE_SCHEDULED_REPORT.ERROR, error));
  }
}

function* deleteScheduledReport() {
  yield takeLatest(reportV2ActionTypes.DELETE_SCHEDULED_REPORT.REQUEST, _deleteScheduledReport);
}

function* _getReportsById(action) {
  const {
    params, callback,
  } = action;
  try {
    yield put(ReportV2Actions.getReportsByIdLoading(true));
    const reportsV2List = yield reportV2Services.getReportsV2List(params);
    yield put(ReportV2Actions.getReportsByIdSuccess(reportsV2List));
    yield put(ReportV2Actions.getReportsByIdLoading(false));
    if (callback) {
      callback(reportsV2List);
    }
  } catch (error) {
    yield put(ReportV2Actions.getReportsByIdLoading(false));
    notification.open({
      type: 'error',
      message: error.message,
      duration: 4,
      placement: 'top',
    });
    yield put(TrackerActions.trackAction(reportV2ActionTypes.GET_REPORTS_BY_ID.ERROR, error));
  }
}

function* getReportsById() {
  yield takeEvery(reportV2ActionTypes.GET_REPORTS_BY_ID.REQUEST, _getReportsById);
}


export default function* reportV2Saga() {
  yield all([
    getReportsV2List(),
    filterReportsV2List(),
    getReportsV2ListDetail(),
    deleteScheduledReport(),
    getReportsById(),
  ]);
}
